export default __webpack_public_path__ + "static/media/background.ac56b707.jpg";